import { observable, computed } from 'mobx';

import { App, ArrayApp, Model, AppRegistry } from 'core/index';

import { FileModel, FileApp } from 'apps/file/app';
import { SpaceModel, SpaceApp } from 'apps/space/app';
import { SmallThreeColumnLayout } from 'apps/layout';

export class ChannelModel extends Model {
  static registryName = 'ChannelModel';
  static ModelProps = {
    avatar: FileModel,
    inSpace: SpaceModel,
    story: 'StoryModel',
  };

  @observable id = '';
  @observable avatar = null;
  @observable name = '';
  @observable moderators = [];
  @observable inSpace = null;
  @observable taggedCount = 0;
  @observable featuredIn = '';
  @observable story = null;
  @observable ctas = [];
  @observable configuration = null;
  // @observable hasModerators = false

  /*
   * CTA expected structure:
   * [
   *  {
   *    'name': String,
   *    'text': String,
   *    'navigation': {
   *      'route': String,
   *      'params': Object
   *     }
   *    'disabled': Boolean,
   *  }
   * ]
   *
   * 'name' is used for composing the event name
   * 'text' will be the text displaed on the button
   * 'disabled' controls the button disabled attribute
   * 'navigation' uses the frontend route names and (optionally) params
   */
}

export class ChannelApp extends App {
  static registryName = 'ChannelApp';
  static AppProps = {
    avatar: FileApp,
    inSpace: SpaceApp,
    story: 'StoryApp',
  };

  static Model = ChannelModel;
  @computed get isModerator() {
    // TODO:
    // if (this.moderators.includes(clientStore.signedInProfile)) {
    //   return true;
    // }
    return false;
  }

  @computed get isCompetition() {
    return !!this.featuredIn && this.featuredIn.includes('competition');
  }

  @computed get CTAs() {
    return JSON.parse(this.ctas);
  }

  @computed get sections() {
    const configurationObject = JSON.parse(this.configuration);
    return configurationObject?.sections || [];
  }

  @computed get isLanding() {
    return this.featuredIn?.includes('landing');
  }
}

export class ChannelsApp extends ArrayApp {
  static registryName = 'ChannelsApp';
  static ElementApp = ChannelApp;
  cardLayout = new SmallThreeColumnLayout();
}

AppRegistry.add(ChannelsApp);
